<template>
    <div class="videoMain" ref="playWndBox" v-if="showLive" :style="{width:setWidth,height:setHeight}">
      <div id="play" class="play" ref="play"></div>
    </div>
  </template>
  <script>
import axios from 'axios'
import { decrypt } from '@/utils/jsencrypt'
  export default {
    data() {
      return {
        visionList:[],
        setWidth:'',
        setHeight:'',
        showLive: true,
        // 视频盒子的高度
        playWndHeight: "",
        // 视频盒子的宽度
        playWndWidth: "",
        oWebControl: null,
        initCount: 0,
        pubKey: "",
        EncryptKey: '',
        // cameraIndexCode: "",  // 这里面是监控点编号
        objData: {
          //海康初始化数据
          appkey: "28683477",
          ip: "103.56.152.126",
          secret: "SzOvm8jV1GjNKRVwbYaQ",
          port: 9443,
          playMode: 1, // 0 预览 1回放
          layout: "1x1", //页面展示的模块数【16】
        },
      }
    },
    props: {
      // cameraIndexCode: {
      //   type: String,
      //   default: ''
      // }
    },
    created(){
      let height=window.innerHeight
      if(height<=690){
      this.setWidth='70%'
      this.setHeight='70%'
    }else if(height<=720){
      this.setWidth='82%'
      this.setHeight='78%'
    }else if(height<=765){
      this.setWidth='85%'
      this.setHeight='82%'
    }else if(height<=775){
      this.setWidth='88%'
      this.setHeight='84%'
    }else if(height<=820){
      this.setWidth='92%'
      this.setHeight='87%'
    }else if(height<=845){
      this.setWidth='95%'
      this.setHeight='91%'
    }else if(height<=890){
      this.setWidth='100%'
      this.setHeight='95%'
    }else {
      this.setWidth='100%'
      this.setHeight='100%'
    }
       axios({
          url: this.$root.BASE_URL + `/system/dict/data/hikvision-list`,
          method: "get",
          headers: {
            authorization: localStorage.getItem('token'),
          },
        }).then((res) => {
          console.log(res)
  if(res.data.code==200){
    console.log(res.data,'系列数----------')
    res.data.data.forEach(item=>{
      let obj={}
      obj.authUuid=item.hikvisionType
      let vision=item.hikvisionConfigMap
      
        obj.appkey=decrypt(vision.hikvision_appkey)
        // let secret=decrypt(vision.hikvision_secret)
        // obj.secret=that.setEncrypt(secret)
        
        obj.secret=decrypt(vision.hikvision_secret)
        obj.ip=decrypt(vision.hikvision_ip)
        obj.port=Number(decrypt(vision.hikvision_port))
        obj.encryptedFields= ""
        this.visionList.push(obj)
      console.log(obj.secret,'vision.hikvision_secret')
    })
   
    console.log(this.visionList,'系列数OMG!!!!!!!!!----------')
  }
        });
    },
    mounted() {
      console.log('首次加载时的到父容器的高度。。。。。。',new WebControl())
      // 首次加载时的到父容器的高度
      this.playWndHeight = this.$refs.play.offsetHeight
      // // 首次加载时的到父容器的宽度
      this.playWndWidth = this.$refs.play.offsetWidth
      // console.log('WebControls.....',this.playWndHeight,this.playWndWidth)
      // 
      // console.log('WebControls',new WebControl())
  
      // 初始化播放器插件
      // this.$nextTick(() => {
      //   this.initPlugin();
      // });
      this.initPlugin()
      this.monitoringWindow()
      // this.play()
    },
    destroyed() {
      this.showLive = false
    //   console.log('视频销毁.....123')
      if (this.oWebControl != null) {
        // 先让窗口隐藏，规避可能的插件窗口滞后于浏览器消失问题
        this.oWebControl.JS_HideWnd();
        // // 销毁当前播放的视频
        // this.oWebControl.JS_RequestInterface({ funcName: "destroyWnd" });
        // // 断开与插件服务连接
        // this.oWebControl.JS_Disconnect();
      }
    },
    methods: {
      // 创建播放实例
      async initPlugin() {
        let that = this
        this.oWebControl = new WebControl({
          szPluginContainer: "play",                       // 指定容器id
          iServicePortStart: 15900,                           // 指定起止端口号，建议使用该值
          iServicePortEnd: 15900,
          szClassId: "23BF3B0A-2C56-4D97-9C03-0CB103AA8F11",   // 用于IE10使用ActiveX的clsid
          cbConnectSuccess: function () {  
            console.log('cbConnectSuccess........')                   // 创建WebControl实例成功											
            that.oWebControl.JS_StartService("window", {         // WebControl实例创建成功后需要启动服务
              dllPath: "./VideoPluginConnect.dll"         // 值"./VideoPluginConnect.dll"写死 
            }).then(function () {                           // 启动插件服务成功
              that.oWebControl.JS_SetWindowControlCallback({   // 设置消息回调
                cbIntegrationCallBack: that.cbIntegrationCallBack
              });
  
              that.oWebControl.JS_CreateWnd("play", that.playWndWidth, that.playWndHeight).then(function () { //JS_CreateWnd创建视频播放窗口，宽高可设定
                console.log('cbConnectSuccess........')
                that.init();  // 创建播放实例成功后初始化
              });
            }, function () { // 启动插件服务失败
            });
          },
          cbConnectError: function () { // 创建WebControl实例失败
            that.oWebControl = null;
            console.log('插件未启动，正在尝试启动，请稍候...')
            $("#play").html("插件未启动，正在尝试启动，请稍候...");
            WebControl.JS_WakeUp("VideoWebPlugin://"); // 程序未启动时执行error函数，采用wakeup来启动程序
            that.initCount++;
            if (that.initCount < 3) {
              setTimeout(function () {
                that.initPlugin();
              }, 3000)
            } else {
              console.log('插件启动失败，请检查插件是否安装')
              $("#play").html("插件启动失败，点击 <a id='downLoad' style='color:blue' >下载<a> 安装！")
              $("#downLoad").click(() => {
  
                that.downLoad()
              })
  
            }
          },
          cbConnectClose: function (bNormalClose) {
            // 异常断开：bNormalClose = false
            // JS_Disconnect正常断开：bNormalClose = true	
            console.log("cbConnectClose");
            that.oWebControl = null;
            console.log('插件未启动，正在尝试启动，请稍候...')
            // $("#play").html("插件未启动，正在尝试启动，请稍候...");
            WebControl.JS_WakeUp("VideoWebPlugin://");
            that.initCount++;
            if (that.initCount < 3) {
              setTimeout(function () {
                that.initPlugin();
              }, 3000)
            } else {
              console.log('插件启动失败，请检查插件是否安装！')
              $("#play").html("插件启动失败，点击 <a id='downLoad' style='color:blue' >下载<a> 安装！")
              $("#downLoad").click(() => {
                that.downLoad()
  
              })
            }
          }
        });
      },
      async downLoad() {
        console.log('下载........')
        let response = await fetch('http://cctv.hbrytech.cn:2123/prod-api/profile/upload/plug/VideoWebPlugin.exe');
        let url = 'http://cctv.hbrytech.cn:2123/prod-api/profile/upload/plug/VideoWebPlugin.exe'
        const a = document.createElement('a')
        a.href = url
        a.download = 'VideoWebPlugin.exe' // 下载后文件名
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click() // 点击下载
        document.body.removeChild(a) // 下载完成移除元素
      },
      // 初始化
      init(callback) {
        console.log('初始化......')
        let that = this;
        that.getPubKey(() => {
          let appkey = that.objData.appkey;                   //综合安防管理平台提供的appkey，必填
          let secret = that.setEncrypt(that.objData.secret); //综合安防管理平台提供的secret，必填
          let ip = that.objData.ip;                           //综合安防管理平台IP地址，必填
          let playMode = that.objData.playMode;               //初始播放模式：0-预览，1-回放
          let port = that.objData.port;                       //综合安防管理平台端口，若启用HTTPS协议，默认443
          let snapDir = "D:\\SnapDir";                        //抓图存储路径
          let videoDir = "D:\\VideoDir";                       //紧急录像或录像剪辑存储路径
          let layout = that.objData.layout;                   //playMode指定模式的布局
          let enableHTTPS = 1;                                //是否启用HTTPS协议与综合安防管理平台交互，这里总是填1
          let encryptedFields = "secret";                     //加密字段，默认加密领域为secret
          let showToolbar = 1;                                //是否显示工具栏，0-不显示，非0-显示
          let showSmart = 0;                                  //是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示
          let buttonIDs = "0,16,256,257,258,259,260,512,513,514,515,516,517,768,769"; //自定义工具条按钮
          let reconnectTimes=3  //重连设置0-无限重连 >0-重连次数 <0-不重连，
        let reconnectDuration=10 //重连间隔时间

          // var toolBarButtonIDs = "2049,2304" // 工具栏上自定义按钮
          that.oWebControl
            .JS_RequestInterface({
              funcName: "init",
              argument: JSON.stringify({
                // appkey: appkey,                 //API网关提供的appkey
                // secret: secret,                 //API网关提供的secret
                // ip: ip,                         //API网关IP地址
                playMode: playMode,             //播放模式（决定显示预览还是回放界面）
                // port: port,                     //端口
                snapDir: snapDir,               //抓图存储路径
                videoDir: videoDir,             //紧急录像或录像剪辑存储路径
                layout: layout,                 //布局
                enableHTTPS: enableHTTPS,       //是否启用HTTPS协议
                encryptedFields: encryptedFields, //加密字段
                showToolbar: showToolbar,       //是否显示工具栏
                showSmart: showSmart,           //是否显示智能信息
                buttonIDs,                      //自定义工具条按钮
                reconnectTimes,
                reconnectDuration
              }),
            })
            .then(function () {
              console.log('初始化成功')
              that.oWebControl.JS_Resize(that.playWndWidth, that.playWndHeight);
             that.oWebControl.JS_RequestInterface({
              funcName: 'setAuthInfo',
              argument: {
                list: that.visionList
              }
            }).then(res => {
              console.log('成功setAuthInfo', that.visionList)
            }).catch(err => {
              console.log('失败setAuthInfo')
            })
            }).catch((err) => {
              console.log(err, '初始化err....')
            })
        });
      },
      play(cameraIndexCode, start, end,haikangType) {
      
        // var startTimeStamp = new Date(start.replace('-', '/').replace('-', '/')).getTime();    //回放开始时间戳，必填
        // var endTimeStamp = new Date(end.replace('-', '/').replace('-', '/')).getTime();        //回放结束时间戳，必填
        var startTimeStamp=new Date(start)
        var endTimeStamp=new Date(end)
        startTimeStamp=(Number(Date.parse(startTimeStamp))-(8*3600*1000))/1000
        endTimeStamp=(Number(Date.parse(endTimeStamp))-(8*3600*1000))/1000
        console.log(start, end,'播放一下', startTimeStamp.toString(), endTimeStamp.toString(), cameraIndexCode,haikangType)
        var recordLocation = 1;                                     //录像存储位置：0-中心存储，1-设备存储
        var transMode = 1;                                          //传输协议：0-UDP，1-TCP
        var gpuMode = 0;                                            //是否启用GPU硬解，0-不启用，1-启用
        var wndId = -1;                                             //播放窗口序号（在2x2以上布局下可指定播放窗口）
        //播放窗口序号（在2x2以上布局下可指定播放窗口）
        let that = this
         let authUuid
      if (haikangType == null) {
        authUuid = 'hikvision'
      } else {
        authUuid = haikangType
      }
        this.oWebControl.JS_RequestInterface({
          funcName: "startPlayback",
          argument: JSON.stringify({
            cameraIndexCode: cameraIndexCode,   //监控点编号
            // startTimeStamp:'1725379200' ,
            // endTimeStamp:'1725551999',  
            startTimeStamp:startTimeStamp.toString() ,
            endTimeStamp:endTimeStamp.toString(),          
            // startTimeStamp: Math.floor(startTimeStamp / 1000).toString(),  //录像查询开始时间戳，单位：秒
            // endTimeStamp: Math.floor(endTimeStamp / 1000).toString(),      //录像结束开始时间戳，单位：秒
            recordLocation: recordLocation,                     //录像存储类型：0-中心存储，1-设备存储
            transMode: transMode,                               //传输协议：0-UDP，1-TCP
            gpuMode: gpuMode,                                   //是否启用GPU硬解，0-不启用，1-启用
            wndId: wndId  ,                                      //可指定播放窗口
            authUuid:authUuid
          })
        }).then(res=>{
          console.log('成功')
        })
        .catch(err=>{
          console.log(err,'失败回放')
        })
      },
      // 获取公钥
      getPubKey(callback) {
        let that = this;
        this.oWebControl
          .JS_RequestInterface({
            funcName: "getRSAPubKey",
            argument: JSON.stringify({
              keyLength: 1024,
            }),
          })
          .then(function (oData) {
            if (oData.responseMsg.data) {
              that.pubKey = oData.responseMsg.data;
              callback();
            }
          });
      },
      // RSA 加密
      setEncrypt(value) {
        let that = this;
        let encrypt = new window.JSEncrypt();
        encrypt.setPublicKey(that.pubKey);
        this.EncryptKey = encrypt.encrypt(value)
        // console.log('setEncrypt',this.EncryptKey)
        return encrypt.encrypt(value);
      },
      // 回调的消息
      cbIntegrationCallBack(oData) {
        let { responseMsg: type } = oData;
        if (type === "error") {
          console.log('errors')
        }
      },
      /**
   * 监听浏览器窗口变化，以及关闭标签页变，并对插件做出处理
   */
      monitoringWindow() {
        let that = this
        // 标签关闭
        $(window).unload(function () {
          if (that.oWebControl != null) {
            that.oWebControl.JS_HideWnd(); // 先让窗口隐藏，规避插件窗口滞后于浏览器消失问题
            that.oWebControl.JS_Disconnect().then(
              function () { },
              function () { }
            );
          }
        });
        window.onresize = () => {
          return (() => {
            // console.log('monitoringWindow...')
            if (that.oWebControl != null) {
              //                 // 首次加载时的到父容器的高度
              //                 that.playWndHeight = that.$refs.playWnd.offsetHeight
              // // // 首次加载时的到父容器的宽度
              // that.playWndWidth = that.$refs.playWnd.offsetWidth
              // console.log(that.playWndWidth)
              that.oWebControl.JS_Resize(
  
                $("#play").width(),
                $("#play").height()
              );
            }
          })();
        };
      },
    }
  }
  </script>
  <style>
  .play {
    /* border: 1px solid red; */
    width: 86%;
    height:84%;
  }
  
  .videoMain {
    width: 100%;
    height: 100%;
    /* margin-left: 100px; */
    /* background-color: red; */
  }
  </style>